export const artifactTypesLabels = {
  COMMENTARY: 'Scope commentary',
  COMPANY_NEWS: 'Company news',
  RATING_NEWS: 'Rating news',
  RESEARCH: 'Company research',
  MONITORING_NOTES: 'Monitoring note',
  FOLLOWED_ANALYSTS: 'Followed analysts',
};

export const newsArtifactsTypes = {
  COMMENTARY: 'COMMENTARY',
  COMPANY_NEWS: 'COMPANY_NEWS',
  RATING_NEWS: 'RATING_NEWS',
  RESEARCH: 'RESEARCH',
  MONITORING_NOTES: 'MONITORING_NOTES',
};

export const artifactTypes = {
  ...newsArtifactsTypes,
  FOLLOWED_ANALYSTS: 'FOLLOWED_ANALYSTS',
  INSTRUMENT: 'INSTRUMENT',
  ENTITY: 'ENTITY',
  SIG_ENTITY: 'SIG_ENTITY',
};
